import { colors } from "theme/dark.colors";
import createTheme from "./common.theme";

const darkTheme = createTheme("dark", colors);

export default darkTheme;